import { gql } from '@efficiently/client-core-graphql-models';

export const GET_CONTENTS = gql(`
	query GetContents($args: ContentSearchArgs!) {
		contents(args: $args) {
			contents {
				...ContentDomainContentFields
			}
			pagination {
				...PaginationFields
			}
		}
	}
`);
